module.exports = __webpack_public_path__ + "img/postavarul.32e49493.jpg";